import React, { useEffect } from "react"
import { View } from "./Themed"
import { Text, Button, TextInput, Divider, Badge, useTheme } from "react-native-paper"
import { ScrollView } from "react-native-gesture-handler"
import { debounce, filter } from "lodash"
import Global from "../constants/global"
import { useDispatch } from "react-redux"
import { listsTask } from "../task/listTasks"
import { useColorScheme } from "react-native"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const OnlyStudentEntry = ({ allExams = [], marks, student, thisExam, subject, std, year, log }) => {
    const [values, setValues] = React.useState({ theory: "", int: 0, pra: 0 })
    const theme = useTheme()
    const dark = useColorScheme() == "dark"
    const dispatch = useDispatch()
    //  
    React.useEffect(() => {
        let th = (marks?.theory == 0 || marks?.theory == "0") ? 0 :
            ((marks?.theory == "" || marks?.theory == undefined) ? "" :
                (marks?.theory ? marks?.theory : 0))
        // //console.log(student.name, th, marks)
        setValues({ theory: th, pra: marks?.practical ? marks?.practical : 0, int: marks?.internal ? marks?.internal : 0 })
    }, [marks])

    useEffect(() => {
        updateMarksCombo(0, values, student.id)
    }, [values])

    const updateMarksCombo = (what: number, m, student_id: string) => {
        const ent = { student_id: student_id, subject_id: subject?.id }
        const gotMarks = pung(m)
        ent.status = Global.getPassFail(gotMarks, subject?.totalMarks)
        if (m.theory == "Absent") {
            ent.status = "Absent"
        }
        if (m.entry) {
            ent.entry = true
        }
        ent.theory = parseFloat(m.theory) ? parseFloat(m.theory) : (m.theory == "" || m.theory == "Absent") ? m.theory : 0
        ent.internal = parseFloat(m.int) ? parseFloat(m.int) : m.int == "" ? m.int : 0
        ent.practical = parseFloat(m.pra) ? parseFloat(m.pra) : m.pra == "" ? m.pra : 0
        //        //console.log(what, ent, m.entry)
        if (m.entry) {
            dispatch(listsTask.actions.updateActivity({ type: "ExamDump", data: ent, tocheck: "student_id" }))
        }
    }


    function getColor() {
        if (values?.theory == "Absent") {
            return dark ? "gray" : "lightgray"
        }
        // const combo = Global.getCombo({ theory: values?.theory, internal: values?.int, practical: values?.pra })
        const t = pung(values)
        const stat = values.theory === "" ? "" : Global.getPassFail(t, subject?.totalMarks)

        const rtval = (stat == "Fail" ? (theme.dark ? "#962424" : "#ffe6e6") :
            stat == "Pass" ? (theme.dark ? "#2d6e43" : "#ccffdd") :
                "transparent")

        // //console.log(student.name, "COMBO=" + combo, "STAT=" + stat, "RTVAL=" + rtval, "THEORY=" + values?.theory, values, "PASSORFAIL=" + Global.getPassFail(combo, subject?.totalMarks), "TOTALMARKS=" + subject?.totalMarks)

        return rtval
    }
    function getValue(marks, id, sid) {
        try {
            const t1 = values?.theory
            const i1 = values?.int ? values?.int : 0
            const p1 = values?.pra ? values?.pra : 0
            const t = Global.getInt(t1)
            const i = Global.getInt(i1)
            const p = Global.getInt(p1)

            const tt = t == "Absent" ? 0 : (t + i + p)
            const tm = marks[op.year][id][sid].totalMarks
            ////console.log(marks[op.year][id][sid], t, "-", i, "-", p)
            return { theory: tt, status: t == "Absent" ? 0 : tt, pc: t == "Absent" ? 0 : (tt * 100) / tm }
        } catch (e) {
            return { theory: 0, status: 0, pc: 0 }
        }
    }

    let mar1 = getValue(marks, allExams?.e1?.id, subject.id)
    const ab = values?.theory == "Absent"
    const thisExamMarks = (ab ? 0 : values?.theory) + (values?.int ? values?.int : 0) + (values?.pra ? values?.pra : 0)
    const thisStatus = { theory: ab ? "Absent" : thisExamMarks, status: thisExam, pc: ab ? 0 : (thisExam * 100) / marks?.totalMarks }
    if (allExams?.e1?.id == thisExam.exam.id) {
        mar1 = thisStatus
    }
    let mar2 = getValue(marks, allExams?.e2?.id, subject.id)
    if (allExams?.e2?.id == thisExam.exam.id) {
        mar2 = thisStatus
    }
    let internal = getValue(marks, allExams?.internal?.id, subject.id)
    if (allExams?.internal?.id == thisExam.exam.id) {
        internal = thisStatus
    }
    let ffinal = getValue(marks, allExams?.e3?.id, subject.id)
    if (allExams?.e3?.id == thisExam.exam.id) {
        ffinal = thisStatus
    }

    const tot = pung(values)
    // //console.log("latest", values, tot)
    return <View style={{ margin: 5, marginTop: 20 }}>
        <View style={{ backgroundColor: getColor(), borderRadius: 5, }}>

            {student["class" + year]?.left == true ?
                <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: 50, textAlign: "center" }} variant="headlineSmall">{student["class" + year]?.roll + ""}</Text>
                    <Text style={{ textDecorationLine: 'line-through' }}>LEFT {student.name}</Text>
                </View>
                : <View style={{ flexDirection: "row", backgroundColor: "transparent" }}>
                    <Text style={{ width: 50, textAlign: "center" }} variant="headlineSmall">{student["class" + year]?.roll + ""}</Text>

                    <View style={{ flex: 1, backgroundColor: "transparent" }}>
                        <Text variant="titleLarge" style={{ backgroundColor: "transparent" }}>{student.name}</Text>
                        <View style={{ flexDirection: "row", alignItems: "center", flex: 1, backgroundColor: "transparent" }}>
                            {subject?.theoryMarks ?
                                <TextInput
                                    disabled={values?.theory == "Absent"}
                                    selectTextOnFocus
                                    // value={"" + (values?.theory !== undefined ? (values?.theory == 0 && marks?.entry !== true) ? "" : values?.theory : "")}
                                    value={values?.theory + ""}
                                    label={"Theory Marks"}
                                    placeholder={"enter " + (subject?.practicalMarks > 0 ? "theory" : "marks") + " here..."}
                                    style={{
                                        backgroundColor: "transparent",
                                        flex: 1,
                                        fontSize: 25
                                    }}
                                    onChangeText={(t) => {
                                        if (t == "") {
                                            setValues(p => ({ ...p, theory: "" }))
                                        } else {

                                            let pint = parseFloat(t)
                                            if (!Number.isNaN(pint) && pint <= subject.theoryMarks && tot <= subject.totalMarks) {
                                                // const combo = Global.getCombo({ theory: pint, internal: values?.internal, practical: values?.practical })
                                                // if (combo <= subject.totalMarks) {
                                                // //console.log("zero loading", pint)
                                                setValues(p => ({ ...p, theory: t, entry: true }))
                                                // updateMarksCombo(0, pint + "", student.id)
                                                // debounceLoadData({ o1: 0, o2: pint + "", o3: values.student_id, change: new Date().getTime() })
                                                // }
                                            } else {
                                                if (t == "") {
                                                    setValues(p => ({ ...p, theory: 0, entry: true }))
                                                }
                                                // if (t == "") {
                                                //     debounceLoadData({ o1: 0, o2: "", o3: student.id, change: new Date().getTime() })
                                                // } else {
                                                //     if (Number.isNaN(pint)) {
                                                //         debounceLoadData({ o1: 0, o2: 0, o3: student.id, change: new Date().getTime() })
                                                //     }
                                                // }
                                            }
                                        }
                                    }
                                    }
                                    dense keyboardType="decimal-pad" /> :
                                <Text>{values?.theory ? values?.theory : ""}</Text>}
                            {(subject?.internalMarks > 0 || subject?.practicalMarks > 0) && < View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
                                {subject?.internalMarks > 0 && <TextInput
                                    disabled={values?.theory == "Absent"}
                                    selectTextOnFocus
                                    value={"" + (values?.int + "")}
                                    label={"Internal "}
                                    placeholder={"enter Internal here..."}
                                    style={{
                                        flex: 1, backgroundColor: "transparent", fontSize: 25
                                    }}
                                    onChangeText={(t) => {
                                        // op.updateMarks(0, t, values.student_id)
                                        // //console.log(t)

                                        // //console.log("pt", t)
                                        if (t == "") {
                                            setValues(p => ({ ...p, int: "" }))
                                        } else {
                                            const pint = parseFloat(t)
                                            if (!Number.isNaN(pint) && pint <= subject.internalMarks && tot <= subject.totalMarks) {
                                                // const combo = Global.getCombo({ theory: values?.theory, internal: pint, practical: values?.pra })
                                                // //console.log("pt c",combo,values,subject.totalMarks  )
                                                // if (combo <= subject.totalMarks) {
                                                // //console.log("debunk",combo,values,subject.totalMarks  )
                                                setValues(p => ({ ...p, int: pint, entry: true }))
                                                // debounceLoadData({ o1: 1, o2: pint, o3: student.id })
                                                // }
                                            } else {
                                                // if (Number.isNaN(pint)) {
                                                if (t == "") {
                                                    setValues(p => ({ ...p, int: 0, entry: true }))
                                                }
                                                // if (t = "") {
                                                //     debounceLoadData({ o1: 1, o2: "", o3: student.id })
                                                // } else {
                                                //     debounceLoadData({ o1: 1, o2: 0, o3: student.id })
                                                // }
                                                // }
                                            }
                                        }

                                    }}

                                    dense keyboardType="decimal-pad" />}
                                {subject?.practicalMarks > 0 && <TextInput disabled={values?.theory == "Absent"}
                                    selectTextOnFocus
                                    value={"" + (values?.pra + "")} label={"Practicle "} placeholder={"enter Practicle Marks here..."}
                                    style={{ flex: 1, backgroundColor: "transparent", fontSize: 25 }}
                                    onChangeText={(t) => {
                                        // op.updateMarks(0, t, values.student_id)
                                        if (t == "") {
                                            setValues(p => ({ ...p, pra: "" }))
                                        } else {

                                            const pint = parseFloat(t)
                                            if (!Number.isNaN(pint) && pint <= subject.practicalMarks && tot <= subject.totalMarks) {
                                                // const combo = Global.getCombo({ theory: values?.theory, int: values?.int, pra: pint })
                                                // if (combo <= subject.totalMarks) {
                                                setValues(p => ({ ...p, pra: pint, entry: true }))
                                                // debounceLoadData({ o1: 2, o2: pint, o3: student.id })
                                                // }
                                            } else {
                                                // //console.log("t0000 1=" + t + "=", t == "")
                                                if (t == "") {
                                                    // //console.log("t0000 2", t)
                                                    setValues(p => ({ ...p, pra: 0, entry: true }))
                                                    // debounceLoadData({ o1: 2, o2: 0, o3: student.id })
                                                }
                                            }
                                        }
                                    }}
                                    dense keyboardType="decimal-pad" />}
                            </View>}
                            <Button focusable={false} onPress={() => {
                                const newVal = values?.theory == "Absent" ? 0 : "Absent"
                                // updateMarksCombo(0, newVal, student.id)
                                setValues(p => ({ ...p, theory: newVal, entry: true }))
                            }}  >{values?.theory == "Absent" ? "Present" : "Absent"}</Button>
                        </View>
                        <InfoBar std={std} log={log} student={student} subject={subject} thisExam={thisExam} values={values} isPractical={subject?.practicalMarks > 0} />
                        <Divider />
                    </View>
                </View>
            }
            <Divider leftInset />
        </View>
    </View >
}

function b(v) {
    const bv = parseFloat(v) ? parseFloat(v) : 0
    return bv
}

const InfoBar = React.memo(({ log, student, subject, thisExam, values, std, isPractical }) => {
    const cls = thisExam?.forClass?.find(f => f.classNo == std?.classNo)
    const thisSub = cls?.subjects?.find(f => f.id == subject?.id)
    const thisTotalMarks = thisSub?.totalMarks ? thisSub?.totalMarks : 0


    let curVal = pung(values)
    let tot = curVal
    let totalPc = 0
    let pcCount = 0
    let myPcAvg = 0
    let thisEx = 0
    let totInternal = thisExam?.isInternal ? curVal : 0
    let totOther = 0
    let subIndex = 0 // for + sign ahead of bar only
    // //console.log("log", log)
    const w = 35
    const fs = 11
    return <View>

        <ScrollView horizontal contentContainerStyle={{ alignItems: "center" }}>
            {log.map((l, i) => {
                let m
                let baseData
                let filSubject
                let totMarks
                let status = ""
                let exName = ""
                let isRepeat = false
                if (l?.data?.isInternal) {
                    if (thisExam?.isInternal == l?.data?.isInternal) {
                        isRepeat = true
                    } else {
                        baseData = l?.data?.InternalReport

                        filSubject = baseData.find(b => b.id == subject?.id)

                        const c = filSubject?.students?.find(f => f.id == student.id)
                        // //console.log("filSubject", c?.internal, filSubject, c, student.id, subject?.id)
                        m = c?.internal
                        totMarks = filSubject?.totalMarks
                        totInternal = totInternal + (typeof m == "number" ? m : 0)
                        exName = l?.data?.id?.substring(0, 3)
                        subIndex++
                    }
                } else {

                    baseData = l?.data?.SummarySheet
                    if (thisExam?.name == baseData?.examName) {
                        isRepeat = true
                    } else {
                        const sm = baseData?.studentList?.find(ss => ss.name == student.name)

                        const m1 = sm?.subjectMarks?.[subject?.id]
                        m = sm?.subjectMarks?.[subject?.id]?.marks

                        const se = l.data?.SubjectSheet?.subjectList?.find(f => f.name == subject?.name)
                        totMarks = se?.totalMarks
                        totOther = totOther + (typeof m == "number" ? m : 0)
                        exName = baseData?.examName?.substring(0, 6)
                        status = m1?.status
                        subIndex++
                    }
                }
                tot = tot + (typeof m == "number" ? m : 0)

                totalPc = totalPc + ((typeof m == "number" && m > 0 && totMarks) ? ((100 * m) / totMarks) : 0)
                pcCount = pcCount + ((typeof m == "number" && m > 0 && totMarks) ? 1 : 0)
                myPcAvg = (totalPc / pcCount)
                thisEx = ((thisTotalMarks * myPcAvg) / 100)

                // //console.log(m, l)
                return !isRepeat ? <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                    <View style={{ width: w, alignItems: "center", marginRight: 2 }}>
                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                            {subIndex > 1 && <Text>+</Text>}
                            <Text style={{ borderBottomWidth: 1, textAlign: "center", width: w, color: status == "Fail" ? "red" : undefined }}>{m ? m : m == 0 ? "00" : "  "}</Text>
                        </View>
                        <Text style={{ fontSize: fs, color: status == "Fail" ? "red" : undefined, overflow: "hidden" }}>{exName}</Text>
                    </View>
                </View> : null
            })}
            <View style={{ marginLeft: 2, alignItems: "center", marginRight: 2 }}>
                {/* <Text style={{ color: values?.int < 7 ? "red" : undefined }}>{values?.int ?  "+ " + values?.int : " "}</Text>
                <Text style={{ color: values?.int < 7 ? "red" : undefined, borderTopWidth: 1, overflow: "hidden" }}>{thisExam?.name?.substring(0, 6)}</Text> */}
                <View style={{ flexDirection: "row", }}>
                    <Text>+</Text>
                    <Text style={{ borderBottomWidth: 1, textAlign: "center", width: w, color: "blue" }}>{curVal}</Text>
                </View>
                <Text style={{ fontSize: fs, color: "blue", overflow: "hidden" }}>{thisExam?.name?.substring(0, 3)}</Text>
            </View>

            {
                (tot !== values?.int) && <View style={{ marginLeft: 2, marginRight: 2, justifyContent: "center" }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text>=</Text>
                        {/* <Text variant="titleLarge" style={{ borderBottomWidth: 1, textAlign: "center", width: 80, color: tot < 7 ? "red" : undefined }}>{Math.round(tot / (isPractical ? 1 : 2))}</Text> */}
                        <Text variant="titleMedium" style={{ borderBottomWidth: 1, textAlign: "center", width: w, color: tot < 7 ? "red" : undefined }}>{Math.round(tot)}</Text>
                    </View>
                    <Text style={{ fontSize: fs, width: w, textAlign: "center", color: tot < 7 ? "red" : undefined, overflow: "hidden" }}>{"કુલ"}</Text>
                </View>
            }
            {tot < (isPractical ? 33 : 66) && (tot !== values?.int) && <MaterialCommunityIcons name="arrow-right" size={14} />}
            {tot < (isPractical ? 33 : 66) && (tot !== values?.int) && <View style={{ marginLeft: 2, marginRight: 2, justifyContent: "center", alignItems: "center", width: 82 }}>
                <View style={{ flexDirection: "row", alignItems: "center", borderBottomWidth: 1, }}>
                    <Text variant="titleMedium" style={{ width: 82, backgroundColor: "red", color: "white", borderBottomWidth: 1, textAlign: "center" }}>{tot - (isPractical ? 33 : 66)}</Text>
                </View>
                <Text style={{ fontSize: fs, width: 82, textAlign: "center", color: tot < 7 ? "red" : undefined, overflow: "hidden" }}>{"પાસ થવામાં ખૂટતા"}</Text>
            </View>}

        </ScrollView >
    </View >
})
export default React.memo(OnlyStudentEntry)

function pung(v) {
    const t = (parseFloat(v?.theory) ? parseFloat(v?.theory) : 0)
    const i = (parseFloat(v?.int) ? parseFloat(v?.int) : 0)
    const p = (parseFloat(v?.pra) ? parseFloat(v?.pra) : 0)
    // //console.log("pung", t, i, p)
    return t + i + p
}
